import { Block } from '@/types/metadata/metadata';
import { createContext } from 'react';

type MetadataBlockContextType = {
  metadataBlock: Block | undefined;
};

/**
 * A Context for use within block settings.
 * Will open up possibility to access the block's metadata instantly.
 */
export const MetadataBlockContext = createContext<MetadataBlockContextType>({ metadataBlock: undefined });
